import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ErrorBoundary from '../components/ui/ErrorBoundary';
import FieldError from '../components/ui/FieldError';



const BusinessType = () => {
  const { user, updateUser } = useAuth();

  // Initialize selectedType from stored user data if available
  const [selectedType, setSelectedType] = useState(user?.businessType || '');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const navigate = useNavigate();
  
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // Keep local selection in sync if user data changes elsewhere
  useEffect(() => {
    if (user?.businessType) {
      setSelectedType(user.businessType);
    }
  }, [user?.businessType]);

  const businessTypes = [
    {
      id: 'individual',
      title: 'Individual',
      description: 'Perfect for solo entrepreneurs and freelancers starting their journey',
      features: ['Quick setup', 'Personal branding', 'Direct customer connection']
    },
    {
      id: 'sole-proprietorship',
      title: 'Sole Proprietorship',
      description: 'Ideal for established independent business owners looking to grow',
      features: ['Business registration', 'Tax benefits', 'Professional credibility']
    },
    {
      id: 'corporation',
      title: 'Corporation',
      description: 'Best for established companies with multiple stakeholders',
      features: ['Limited liability', 'Investment opportunities', 'Corporate structure']
    },
    {
      id: 'partnership',
      title: 'Partnership',
      description: 'Great for collaborative businesses with shared ownership',
      features: ['Shared responsibilities', 'Combined expertise', 'Joint decision making']
    }
  ];

  const handleTypeSelect = (typeId) => {
    setSelectedType(typeId);
    setError('');
  };

  const handleContinue = async () => {
    if (!selectedType) {
      setError('Please select a business type to continue');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      // Update user data with selected business type
      const selectedBusiness = businessTypes.find(type => type.id === selectedType);
      updateUser({
        businessType: selectedType,
        businessTitle: selectedBusiness.title
      });

      setSuccess('Business type selected successfully!');
      
      // Navigate to representative details page
      setTimeout(() => {
        navigate('/representative-details');
      }, 1000);

    } catch (err) {
      setError('Failed to save business type. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ErrorBoundary>
      <div className="business-type-container">
        <div className="business-type-content">
          <div className="business-type-header">
            <h1 className="business-type-title">Choose Your Business Type</h1>
            <p className="business-type-subtitle">
              Select the option that best describes your business structure
            </p>
          </div>

          <div className="business-types-grid">
            {businessTypes.map((type) => (
              <div
                key={type.id}
                className={`business-type-card ${selectedType === type.id ? 'selected' : ''}`}
                onClick={() => handleTypeSelect(type.id)}
              >

                

                
                <div className="business-type-info">
                  <h3 className="business-type-name">{type.title}</h3>
                  <p className="business-type-description">{type.description}</p>
                </div>

                <div className="selection-indicator">
                  <div className={`radio-button ${selectedType === type.id ? 'checked' : ''}`}>
                    {selectedType === type.id && <div className="radio-dot"></div>}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="business-type-actions">
            <FieldError error={error} />

            
            <button
              onClick={handleContinue}
              disabled={!selectedType || isLoading}
              className={`btn btn-primary continue-btn ${isLoading ? 'loading' : ''} ${!selectedType ? 'disabled' : ''}`}
            >
              {isLoading ? 'Setting up...' : 'Continue'}
            </button>
          </div>

          {/* <div className="business-type-footer">
            <p className="help-text">
              Need help choosing? <a href="#" className="help-link">View detailed comparison</a>
            </p>
          </div> */}
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default BusinessType;
